import React from "react";
import "./Looking_for_support.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

function Looking_for_support() {
  return (
    <>
      <section className="Looking_for_support">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-4">
              <div className="Looking_for_support_img_holder">
                <div className="img-holder">
                  <img
                    className="Looking_for_support_img"
                    src={
                      process.env.PUBLIC_URL +
                      "/Assets/Images/Home/Looking_for_support/section_img.png"
                    }
                  />
                </div>

                <div className="social_icon">
                  <div>
                    <div className="img-holder">
                      <FontAwesomeIcon icon={faFacebookF} />
                    </div>

                    <div className="img-holder">
                      <FontAwesomeIcon icon={faLinkedinIn} />
                    </div>

                    <div className="img-holder">
                      <FontAwesomeIcon icon={faInstagram} />
                    </div>
                  </div>
                </div>

                <div className="overlay_holder"></div>
              </div>
            </div>

            <div className="col-md-8 col-8 main_content_holder">
              <div className="content_holder">
                <div className="text_holder">
                  <div>
                    <h6>
                      Contact our expert support team for Fast and reliable
                      Assistance
                    </h6>
                    <h1>Looking for support?</h1>
                  </div>
                </div>

                <div className="number_holder">
                  <div className="call_icon">
                    <FontAwesomeIcon icon={faPhone} />
                  </div>
                  <p>Toll-Free: 1800-268-2424</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Looking_for_support;
